import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import NoOrganization from "@/components/NoOrganization";
import BlockedOrg from "@/components/BlockedOrg";
import { Loader2 } from "lucide-react";

function FullScreenLoader() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-background" data-testid="app-loader">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}

export default function ProtectedRoute() {
  const { loading, user, organizations, organization } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.platform_role === "super_admin") return <Navigate to="/admin" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  if (!organizations || organizations.length === 0) return <NoOrganization />;
  if (organization?.access_blocked) return <BlockedOrg reason={organization.blocked_reason} />;
  // Grace period elapsed (past_due > 7 days): only billing/settings and Support stay reachable.
  if (organization?.restricted && !["/parametres", "/support"].includes(location.pathname))
    return <Navigate to="/parametres" replace />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
